import { Bar } from 'react-chartjs-2';
import { Chart, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend } from 'chart.js';
import { useState, useEffect } from 'react';
import axios from 'axios';

Chart.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

const AnalyticsCustomerGraph = () => {
  const [eventCountsByType, setEventCountsByType] = useState({
    corporate: Array(12).fill(0),
    wedding: Array(12).fill(0),
    birthday: Array(12).fill(0),
    other: Array(12).fill(0),
  });

  useEffect(() => {
    fetchEvents().then(data => {
      const counts = {
        corporate: Array(12).fill(0),
        wedding: Array(12).fill(0),
        birthday: Array(12).fill(0),
        other: Array(12).fill(0),
      };

      data?.forEach(event => {
        const eventDate = new Date(event.eventDate);
        const month = eventDate.getMonth(); // 0 = Jan, 11 = Dec
        const type = event.eventType;

        if (counts[type]) {
          counts[type][month]++;
        } else {
          counts.other[month]++;
        }
      });

      setEventCountsByType(counts);
    });
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/business/events`, { withCredentials: true });
      return response.data.data;
    } catch (error) {
      console.error('There has been a problem with your fetch operation:', error);
    }
  };

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const data = {
    labels: months,
    datasets: [
      {
        label: 'Corporate',
        data: eventCountsByType.corporate,
        backgroundColor: '#F99600',
        barThickness: 20,
      },
      {
        label: 'Wedding',
        data: eventCountsByType.wedding,
        backgroundColor: '#21A62C',
        barThickness: 20,
      },
      {
        label: 'Birthday',
        data: eventCountsByType.birthday,
        backgroundColor: '#FFC700',
        barThickness: 20,
      },
      {
        label: 'Other',
        data: eventCountsByType.other,
        backgroundColor: '#D9D9D9',
        barThickness: 20,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        align: 'start',
        labels: {
          usePointStyle: true,
          boxWidth: 18,
          padding: 40,
        },
      },
      title: {
        display: true,
        align: 'start',
        text: 'Customer Growth',
        padding: 0,
        color: '#1C1154',
        font: {
          size: 24,
          family: 'Poppins',
        },
      },
    },
    layout: {
      padding: {
        top: 20,
      },
    },
    scales: {
      x: {
        stacked: true,
        beginAtZero: true,
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        stacked: true,
        border: {
          color: '#ffffff',
        },
      },
    },
  };

  return (
    <div 
      style={{ 
        backgroundColor: '#FFFFFF', 
        padding: "3%", 
        width: '100%', 
        boxSizing: 'border-box',
      }}
    >
      <div 
        style={{ 
          position: 'relative', 
          width: '100%',
          aspectRatio: '2 / 1', // <--- THE MAGIC BULLET: CSS controls the height now
          minHeight: '250px' // Fallback to ensure it never gets totally squished on mobile
        }}
      >
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default AnalyticsCustomerGraph;